import{m as n}from"./chunk-HBP5N4FR.js";n();var d=()=>Boolean((typeof window!="undefined"?window:{}).elrondWallet);export{d as a};
//# sourceMappingURL=chunk-DAGAOQXG.js.map
